import { type AnyAction } from 'redux';
import {
	call,
	put,
	takeLatest,
	type CallEffect,
	type ForkEffect,
	type PutEffect,
	type SelectEffect
} from 'redux-saga/effects';
import { IncentivesActionType } from './enums';
import {
	fetchIncentivesPercentageShares,
	getTeamWiseIncentives,
	getTeamWiseIncentivesByProjectId
} from './api';

type IncentivesSagaEffect = Generator<CallEffect<any> | PutEffect<any> | SelectEffect> | any;
type IncentivesSagaFormEffect = Generator<ForkEffect<void>>;

export function* fetchTeamWiseShareEffect(action: AnyAction): IncentivesSagaEffect {
	try {
		const { data }: any = yield call(fetchIncentivesPercentageShares);
		if (action.payload?.successCB) {
			action.payload.successCB(data);
		}
		yield put({
			type: IncentivesActionType.STORE_TEAM_WISE_SHARE,
			payload: data
		});
	} catch (error: unknown) {
		if (action.payload?.errorCB) {
			action.payload.errorCB(error);
		}
	}
}

export function* fetchTeamWiseIncentivesEffect(action: AnyAction): IncentivesSagaEffect {
	try {
		const { offset, pageSize } = action.payload;
		const { data }: any = yield call(getTeamWiseIncentives, { offset, pageSize });
		if (action.payload?.successCB) {
			action.payload.successCB(data);
		}
		yield put({
			type: IncentivesActionType.STORE_TEAM_WISE_INCENTIVES,
			payload: data
		});
	} catch (error: unknown) {
		if (action.payload?.errorCB) {
			action.payload.errorCB(error);
		}
	}
}

export function* fetchTeamWiseIncentivesByProjectIdEffect(action: AnyAction): IncentivesSagaEffect {
	try {
		const { projectId } = action.payload;
		const { data }: any = yield call(getTeamWiseIncentivesByProjectId, projectId);
		if (action.payload?.successCB) {
			action.payload.successCB(data);
		}
		yield put({
			type: IncentivesActionType.STORE_TEAM_WISE_INCENTIVES_BY_PROJECT_ID,
			payload: data
		});
	} catch (error: unknown) {
		if (action.payload?.errorCB) {
			action.payload.errorCB(error);
		}
	}
}

export function* fetchTeamWiseShareSaga(): IncentivesSagaFormEffect {
	yield takeLatest(IncentivesActionType.FETCH_TEAM_WISE_SHARE, fetchTeamWiseShareEffect);
}

export function* fetchTeamWiseIncentivesSaga(): IncentivesSagaFormEffect {
	yield takeLatest(IncentivesActionType.FETCH_TEAM_WISE_INCENTIVES, fetchTeamWiseIncentivesEffect);
}

export function* fetchTeamWiseIncentivesByProjectIdSaga(): IncentivesSagaFormEffect {
	yield takeLatest(IncentivesActionType.FETCH_TEAM_WISE_INCENTIVES_BY_PROJECT_ID, fetchTeamWiseIncentivesByProjectIdEffect);
}
